import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "newPictureAddPlusIcon",
  "use": "newPictureAddPlusIcon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"newPictureAddPlusIcon\"><path d=\"M12 2v20M2 12h20\" stroke=\"#fff\" stroke-width=\"3\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol